<template>
  <ListeReferentiel
    ref="liste"
    titre="Moyens de paiement"
    icone="bi-credit-card"
    ressource="moyen_paiements"
    tri-defaut="mp.createdAt"
    sens-defaut="desc"
    :options-tri="{ 'Date de création': 'mp.createdAt', Nom: 'mp.nom', 'Mise à jour': 'mp.updatedAt', Statut: 'mp.isEnabled' }"
    placeholder="Nom du moyen de paiement…"
    unite="moyen(s)"
    vide="Aucun moyen de paiement enregistré."
    :colonnes="6"
    :peut-creer="$store.getters.hasPermission('CONFIG_CREER_MOYEN_PAIEMENT')"
    libelle-creer="Nouveau moyen"
    @creer="creation"
  >
    <template #entete>
      <th>Nom</th>
      <th>Statut</th>
      <th class="d-none d-md-table-cell">Créé le</th>
      <th class="d-none d-md-table-cell">Mis à jour le</th>
      <th>Actions</th>
    </template>
    <template #ligne="{ ligne: mode }">
      <td>{{ mode.nom }}</td>
      <td>
        <span :class="['badge', mode.isEnabled ? 'bg-success' : 'bg-secondary']">{{ mode.isEnabled ? 'Activé' : 'Désactivé' }}</span>
      </td>
      <td class="d-none d-md-table-cell">{{ formatDate(mode.createdAt) }}</td>
      <td class="d-none d-md-table-cell">{{ formatDate(mode.updatedAt) }}</td>
      <td>
        <div v-if="$store.getters.hasAnyPermission(['CONFIG_MODIFIER_MOYEN_PAIEMENT', 'CONFIG_SUPPRESSION_MOYEN_PAIEMENT'])" class="dropdown">
          <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" v-dropdown-fixed>Actions</button>
          <ul class="dropdown-menu">
            <li v-if="$store.getters.hasPermission('CONFIG_MODIFIER_MOYEN_PAIEMENT')"><a class="dropdown-item" href="#" @click.prevent="modifier(mode.id)">Modifier</a></li>
            <li v-if="$store.getters.hasPermission('CONFIG_SUPPRESSION_MOYEN_PAIEMENT')"><a class="dropdown-item text-danger" href="#" @click.prevent="supprimer(mode)">Supprimer</a></li>
          </ul>
        </div>
      </td>
    </template>
  </ListeReferentiel>
</template>

<script>
import dayjs from 'dayjs';
import ListeReferentiel from '@/components/commun/ListeReferentiel.vue';

export default {
  name: 'ListeMoyenPaiement',
  components: { ListeReferentiel },
  methods: {
    formatDate(date) {
      return date ? dayjs(date).format('DD/MM/YYYY HH:mm') : '—';
    },
    creation() {
      this.$router.push({ name: 'create_moyen' });
    },
    modifier(id) {
      this.$router.push({ name: 'edit_moyen', params: { id } });
    },
    supprimer(mode) {
      this.$refs.liste.supprimer({
        id: mode.id,
        titre: 'Supprimer le moyen de paiement',
        message: `Supprimer le moyen de paiement « ${mode.nom} » ?`,
        succes: 'Moyen de paiement supprimé.',
      });
    },
  },
};
</script>
